import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { AccessUserInfo, UserDetail } from 'src/app/models';
import { LabModels, LabTestAndProfile } from 'src/app/models/water-lab/lab-manager';
import { LabManagerService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'bart-add-test-to-model',
  templateUrl: './add-test-to-model.component.html',
  styleUrls: ['./add-test-to-model.component.scss']
})
export class AddTestToModelComponent implements OnInit {
  labTestData: LabTestAndProfile[]=[];
  selectedLabTestData : LabTestAndProfile[];
  userInfo: UserDetail;
  rowData:LabModels
  constructor
  (
    private _labManagerService : LabManagerService,
    private _loaderService : LoaderService,
    private _dailogConfig : DynamicDialogConfig,
    private _dynamicDialogRef: DynamicDialogRef,
    private _userService: UserService,

  ) 
  { 
    this.userInfo = AccessUserInfo.getUserInfo();
  }

  ngOnInit() 
  {
    this.getAllLabTests();
    if(this._dailogConfig.data !=null)
    {
      this.rowData=this._dailogConfig.data.rowData
      if(this.rowData && this.rowData.LabTest)
      {
        this.selectedLabTestData = this.rowData.LabTest
        this.selectedLabTestData.sort((a, b) => (a.TestDisplayName < b.TestDisplayName ? -1 : 1))
      }
    }
  }

  getAllLabTests()
  {
    this._loaderService.show()
    this._labManagerService.getAllLabTestsAndProfiles().subscribe(response =>
    {
     this.labTestData  = response
     this._loaderService.hide()
    },
    (error)=>
    {
      this._loaderService.hide()
    })
  }
  closePopup(canCelButtonClicked:boolean)
  {
    this._dynamicDialogRef.destroy();

    if(canCelButtonClicked || undefined)
    {

    //#region User Action Audit
    this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.MODIFY_ASSIGNMENT,
      screenPath:location.pathname,
      key:'ModelID',
      value:this.rowData.ModelID,
      eventDescription:UserActionDescription.MODIFY_ASSIGNMENT_POPUP_CANCEL_CLICKED
    }); 
  //#endregion
    }

  }
  saveMapping()
  {
    let xml = '<xml><mappings>'
    this.selectedLabTestData.forEach(item => {
     xml += "<mapping><mappingid>"+ item.LabTestMasterID +"</mappingid><isprofile>"+ item.IsProfile +"</isprofile></mapping>";
    });
     xml += '</mappings></xml>';
    let param =
    {
      "UPDATELABTESTBYMODEL":
      {
        UserName: this.userInfo.userName,
        ModelId:this.rowData.ModelID,
        MappingJson:xml,
        StartDate:this.rowData.StartDateUTC
      }
    }
    this._loaderService.show()
    this._labManagerService.updateLabTestByModel(param).subscribe(response =>
    {
      this._loaderService.hide()
      this._dynamicDialogRef.close();
    },
    (error)=>
    {
      this._loaderService.hide()
    })

    //#region User Action Audit
    this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.MODIFY_ASSIGNMENT,
      screenPath:location.pathname,
      key:'ModelID',
      value:this.rowData.ModelID,
      eventDescription:UserActionDescription.MODIFY_ASSIGNMENT_POPUP_SAVE_CLICKED
    }); 
    //#endregion
  }
}
